<template>
  <v-layout row>
    <v-flex xs12>
    <v-toolbar app>
    <!-- <v-btn icon><v-icon>keyboard_arrow_left</v-icon></v-btn> -->
    <v-toolbar-title>Pre-Alertas</v-toolbar-title>
    <v-spacer></v-spacer>
     <v-btn icon >
              <v-icon>add</v-icon>
            </v-btn>
  </v-toolbar>
        <v-list two-line class="list-view">
          <template v-for="(item) in items" >
            <v-list-tile class="list-view-item"
              :key="item.title"
              avatar
              ripple
              :to="'/PackageDetails/' + item.id"
            >
              <v-list-tile-content>
                <v-list-tile-title :class="item.color + ' pack-title'">{{ item.title }}</v-list-tile-title> 
                <span class="list-view-item-date">{{item.action}}</span>
                <v-list-tile-sub-title class="mb-3 mt-3 no-hidden-text">{{ item.subtitle }}</v-list-tile-sub-title>
                
                <img src="https://ci6.googleusercontent.com/proxy/rBlYsJ_9fKdR9-vzrRaE0LEqPYy2ZnUrQcMMij1vWFStCRqz4CrwwckNVVuVEMi-2pav2qu6HeEmt04tUDGg93owsUzyg0H2=s0-d-e1-ft#http://www.onecontrolcargosystem.com/banner/rua_1.jpg" alt="">
              </v-list-tile-content>
            </v-list-tile>

          </template>
        </v-list>
        </v-flex>
  </v-layout>
</template>

<script>
export default {
  mounted () {
  },
  data () {
    return {
      clipped: false,
      items: [
        { id: 0, progress:50, color:"bg-gray",  action: '15 min', headline: 'Brunch this weekend?', title: 'Ali Connors', subtitle: "I'll be in your neighborhood doing errands this weekend. Do you want to hang out ?" },
        { id: 1, progress:50, color:"bg-gray", action: '2 hr', headline: 'Summer BBQ', title: 'me, Scrott, Jennifer', subtitle: "Wish I could come, but I'm out of town this weekend." },
        { id: 2, progress:50, color:"bg-gray", action: '6 hr', headline: 'Oui oui', title: 'Sandra Adams', subtitle: 'Do you have Paris recommendations? Have you ever been?' },
        { id: 3, progress:50, color:"bg-gray", action: '12 hr', headline: 'Birthday gift', title: 'Trevor Hansen', subtitle: 'Have any ideas about what we should get Heidi for her birthday?' },
        { id: 4, progress:50, color:"bg-gray", action: '18hr', headline: 'Recipe to try', title: 'Britta Holt', subtitle: 'We should eat this: Grate, Squash, Corn, and tomatillo Tacos.' }
      ]
    }
  },
  computed: {
    login: function () {
      return this.$store.getters.login
    }
  },
  name: 'App'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
